<template>
  <div class="home" v-if="!isLoading">
    <offer-modal :text-offer="textOffer"/>
    <sign-modal
      :application="form.application"
      :cert-list-box-id="certListBoxId"
      :modal-id="signModalId"
      @show="onShowModal"
    />
    <vue-headful :title="pageTitle"/>
    <ApplicantInfoBlock :roles="applicantInfoRoles"/>
    <form-section
      id="organization-section"
      title="Заявитель"
      :is-first-section="true"
      :hasErrors="hasSectionErrors(errors, 'organization')"
    >
      <organization-form-block
        v-model="form.organization"
        :form="form"
        :errors="errors"
        :organization-subjects="organizationSubjects"
      />
    </form-section>

    <WorkSection
      :updateApplication="updateApplication"
      :application="form.application"
      :subdivisions="terminalSubdivisions"
      :time-of-work-ids="form.timeOfWorkIds"
      :time-of-work="timeOfWork"
    />

    <WorkersSection
      :setResponsibleWorker="setResponsibleWorker"
      :unsetResponsibleWorker="unsetResponsibleWorker"
      title="Работники"
      :errors="errors"
      :visitors="form.visitors"
      :workers="form.workers"
      :nationalities="personalNationalities"
      :identifications="personalIdentifications"
      :addWorker="addWorker"
      :removeWorker="removeWorker"
      :addVisitor="addVisitor"
      :removeVisitor="removeVisitor"
    />

    <form-section
      id="submission-section"
      title="Подача заявки"
      :hasErrors="hasSectionErrors(errors, 'submission')"
    >
      <div class="col-md-12 col-sm-12 col-xs-12">
        <div class="offer-text">
          Нажимая кнопку «Подать заявку» вы соглашаетесь на обработку
          персональных данных и
          <a v-b-modal.modal-offer>с условиями предоставления услуги.</a>
        </div>
        <div class="row text-center form-send-button-block">
          <div class="col-md-3 col-sm-12 col-xs-12">
            {{ /** TODO Implements submit click handler when API endpoint ready */ }}
            <button
              type="button"
              class="btn btn-success btn-primary-white"
              style="width: 100%;" v-html="`Подать заявку`"
            />
          </div>

          <div class="col-md-3 col-sm-12 col-xs-12">
            {{ /** TODO Implements submit click handler when API endpoint ready */ }}
            <button
              type="button"
              class="btn btn-default btn-primary-white"
              style="width: 100%;"
              v-html="`Сохранить черновик`"
            />
          </div>
        </div>
        <div class="row padding40" style="margin-top: -10px;"><div class="col-md-3 col-sm-2 col-xs-0"></div><!----><div class="col-md-3 col-sm-2 col-xs-0"></div></div>
      </div>
    </form-section>
  </div>
</template>

<script>
import ApplicantInfoBlock from '../common/components/application/ApplicantInfoBlock'
import SignModal from '../components/application/form-blocks/SignModal.vue'
import loadCadesplugin from '../common/helpers/signer/cadesplugin_api.js'
import { UserRoles } from '@/enums/UserRoles'
import { ApiClient } from '@/helpers/api-client/ApiClient'
import { cloneObject } from '@/common/helpers'
import { Logger } from '@/common/helpers/Logger'
import applicationFormMixin from '../common/mixins/applicationFormMixin'
import FormSection from '../common/components/application/FormSection'
import OrganizationFormBlock from '@/common/components/application/form-blocks/organization/OrganizationFormBlock'
import hasErrorsMixin from '../common/mixins/hasErrorsMixin'
import { OrganizationSubjects } from '@/enums/OrganizationSubjects'
import WorkSection from '../common/components/WorkSection/WorkSection'
import WorkersSection from '../common/components/WorkersSection/WorkersSection'
import OfferModal from '../common/components/application/OfferModal.vue'
import { VesselAccesses as VesselAccessesEnum } from '@/common/enums/VesselAccesses'

export default {
  name: 'rest-time-application',
  components: {
    ApplicantInfoBlock,
    SignModal,
    FormSection,
    OrganizationFormBlock,
    WorkSection,
    WorkersSection,
    OfferModal
  },

  mixins: [applicationFormMixin, hasErrorsMixin],

  data: () => {
    const defaultForm = {
      organization: {
        subject_id: OrganizationSubjects.Entity,
        name: null,
        inn: null,
        position_of_manager: null,
        director_name: null,
        phone: '',
        innControlSumErr: false,
        innError: false,
        nationality_id: 182
      },
      application: {
        period_count: null,
        period_of: null,
        period_to: null,
        time_of: '00:00',
        time_to: '23:59',
        pass_access: 1,
        application_group_purpose_id: null,
        terminal_region_id: null,
        agent_organization_id: null,
        subdivision_id: null,
        time_type: 'one',
        pass_kind: null,
        additional_purpose: null,
        vessel: null,
        flag: null,
        berth: null,
        vessel_access_id: VesselAccessesEnum.WITHOUT_VESSEL,
        need_agent_check: 0,
        need_additional_purpose: 0
      },
      timeOfWorkIds: [],
      visitors: [],
      workers: [],
      scanCopiesUrls: []
    }

    return {
      textOffer: null,
      signers: undefined,
      needLoadPage: true,
      organizationSubjects: [],
      timeOfWork: [],
      personalNationalities: [],
      personalIdentifications: [],
      terminalSubdivisions: {
        type: Object
      },
      errors: {
        type: Array,
        default: []
      },
      application: {
        type: [Object]
      },
      form: cloneObject(defaultForm),

      applicantInfoRoles: [
        UserRoles.SB,
        UserRoles.SB_TRUCK,
        UserRoles.SB_OTHER,
        UserRoles.SUBDIVISION,
        UserRoles.MANAGEMENT_BUILDING
      ]
    }
  },

  async created() {
    loadCadesplugin()

    if (this.user && this.user.role === UserRoles.GUARD) {
      this.needLoadPage = false
      window.location.href = ApiClient.getGuardScreenUrl()
    }
  },

  updated() {
    this.$nextTick(function () {
      if (this.user && this.user.role && this.check) {
        this.getSigners()
      }
    })
  },

  beforeMount() {
    this.showPreloader()
  },

  beforeRouteUpdate(to, from, next) {
    next()

    this.showPreloader()
    this.form = cloneObject(this.defaultForm)
    this.loadPage()
  },

  mounted() {
    this.loadPage()
  },

  computed: {
    pageTitle() {
      const pageTitle = 'Сервис по оформлению заявок на пропуск'

      if (this.form && this.form.application && this.form.application.number) {
        return `№${this.form.application.number} - ${pageTitle}`
      }

      return pageTitle
    },

    certListBoxId() {
      return `certListBox-${this.form.application.id}`
    },

    signModalId() {
      return 'modal-border'
    }
  },

  methods: {
    async fetchOtherData () {
      await ApiClient.otherData().then((response) => {
        const responseData = response.data
        const otherData = responseData.data

        if (!otherData) {
          return
        }

        this.textOffer = otherData.offer
      })
    },

    setResponsibleWorker(index) { this.$set(this.form.workers[index], 'responsible', true) },
    unsetResponsibleWorker (index) {
      console.log(this.form.workers[index])
      this.$set(this.form.workers[index], 'responsible', false)
    },

    addWorker (visitor = {}) {
      this.form.workers.push(visitor)
    },

    removeWorker (index) {
      return this.form.workers.splice(index, 1)
    },

    addVisitor (visitor = {}) {
      this.form.visitors.push(visitor)
    },

    removeVisitor (index) {
      return this.form.visitors.splice(index, 1)
    },

    updateApplication(application = {}) {
      this.form.application = { ...this.form.application, ...application }
    },

    async loadPage () {
      if (!this.needLoadPage) {
        return
      }

      if (!this.restoredData) {
        await this.fetchApplicationData()
      }

      await this.fetchOtherData()
      await this.fetchExtraApplicationData()
      await this.fetchNationalityMaskData()
      await this.fetchTimeOfWork()

      this.hidePreloader()
    },

    async fetchApplicationData() {
      await ApiClient.applicationData({
        application_id: this.$route.query.application_id,
        access_level: this.$route.query.access_level
      }).then((response) => {
        if (response.status === 403) {
          this.$router.push('/')

          return
        }

        const responseData = response.data
        const applicationData = responseData.data

        if (!applicationData) {
          return
        }

        this.fillOrganization(applicationData.organization)
        this.fillApplication(applicationData.application)
        this.fillVisitors(applicationData.visitors)
      })
    },

    async fetchExtraApplicationData() {
      await ApiClient.extraApplicationData({
        application_id: this.$route.query.application_id,
        access_level: this.$route.query.access_level
      }).then((response) => {
        const responseData = response.data
        const extraApplicationData = responseData.data

        if (!extraApplicationData) {
          return
        }

        this.organizationSubjects = extraApplicationData.organizationSubjects
        this.terminalTariffPeriods = extraApplicationData.terminalTariffPeriods
        this.applicationPurposes = extraApplicationData.applicationPurposes
        this.terminalRegions = extraApplicationData.terminalRegions
        this.terminalSubdivisions = extraApplicationData.terminalSubdivisions
        this.agentOrganizations = extraApplicationData.agentOrganizations
        this.personalNationalities = extraApplicationData.personalNationalities
        this.personalIdentifications = extraApplicationData.personalIdentifications
        this.nationalityDocuments = extraApplicationData.nationalityDocuments
        this.transportTypes = extraApplicationData.transportTypes
        this.terminalTariffTimeTypes = extraApplicationData.terminalTariffTimeTypes
        this.statusActions = extraApplicationData.statusActions
      })
    },

    async fetchNationalityMaskData() {
      await ApiClient.nationalityMaskData().then((response) => {
        this.documentMasks = response.data.data.documentMasks
      })
    },

    fillOrganization(organization) {
      if (!organization) {
        return
      }

      this.form.organization.inn = organization.inn
      this.form.organization.name = organization.name
      this.form.organization.subject_id = organization.subject_id
      this.form.organization.address = organization.address
      this.form.organization.director_name = organization.director_name
      this.form.organization.phone = String(organization.phone)
      this.form.organization.position_of_manager = organization.position_of_manager
      this.form.organization.nationality_id = organization.nationality_id
    },

    fillApplication(application) {
      if (application === null) {
        return
      }

      this.form.application = {
        ...this.form.application,
        ...application
      }
    },

    fillVisitors(visitors) {
      if (!Array.isArray(visitors) || visitors.length === 0) {
        return
      }

      this.form.visitors = visitors
      this.checkVisitorOrganizationBlock()
    },

    fillScanCopies(scanCopies) {
      if (!Array.isArray(scanCopies) || scanCopies.length === 0) {
        return
      }

      this.form.scanCopiesUrls = scanCopies
    },

    async applyApplication() {
      Logger.log('Applying application')

      this.formSending = true
      await this.createApplication()
    },

    onShowModal() {
      const signer = this.signers[Number(this.form.application.id)]

      if (window.cadesplugin) {
        window.cadesplugin.then(function () {
          signer.requestCertificates()
        })
      }
    },

    async fetchTimeOfWork() {
      await ApiClient.getTimeOfWork().then((response) => {
        this.timeOfWork = response.data.data.reduce((obj, item) => Object.assign(obj, { [item.id]: item.name }), {})
      })
    }
  }
}
</script>
